// extracted by mini-css-extract-plugin
export default {"message":"ProcessConfirmationPopup_message__pev8g","centeredFooter":"ProcessConfirmationPopup_centeredFooter__QAMJ0","bold":"ProcessConfirmationPopup_bold__2WYTh"};